import React from "react";

const SettingImg = ({ color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9941 15.6118C13.651 15.6118 14.9941 14.2687 14.9941 12.6118C14.9941 10.9549 13.651 9.61182 11.9941 9.61182C10.3372 9.61182 8.99414 10.9549 8.99414 12.6118C8.99414 14.2687 10.3372 15.6118 11.9941 15.6118Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.99414 13.4917V11.7317C1.99414 10.6917 2.84414 9.83175 3.89414 9.83175C5.70414 9.83175 6.44414 8.55175 5.53414 6.98175C5.01414 6.08175 5.32414 4.91175 6.23414 4.39175L7.96414 3.40175C8.75414 2.93175 9.77414 3.21175 10.2441 4.00175L10.3541 4.19175C11.2541 5.76175 12.7341 5.76175 13.6441 4.19175L13.7541 4.00175C14.2241 3.21175 15.2441 2.93175 16.0341 3.40175L17.7641 4.39175C18.6741 4.91175 18.9841 6.08175 18.4641 6.98175C17.5541 8.55175 18.2941 9.83175 20.1041 9.83175C21.1441 9.83175 22.0041 10.6817 22.0041 11.7317V13.4917C22.0041 14.5317 21.1541 15.3917 20.1041 15.3917C18.2941 15.3917 17.5541 16.6717 18.4641 18.2417C18.9841 19.1517 18.6741 20.3117 17.7641 20.8317L16.0341 21.8217C15.2441 22.2917 14.2241 22.0117 13.7541 21.2217L13.6441 21.0317C12.7441 19.4617 11.2641 19.4617 10.3541 21.0317L10.2441 21.2217C9.77414 22.0117 8.75414 22.2917 7.96414 21.8217L6.23414 20.8317C5.32414 20.3117 5.01414 19.1417 5.53414 18.2417C6.44414 16.6717 5.70414 15.3917 3.89414 15.3917C2.84414 15.3917 1.99414 14.5317 1.99414 13.4917Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SettingImg;
